import { render, staticRenderFns } from "./newhistoryAnalysis.vue?vue&type=template&id=25f72da3&scoped=true&"
import script from "./newhistoryAnalysis.vue?vue&type=script&lang=js&"
export * from "./newhistoryAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./newhistoryAnalysis.vue?vue&type=style&index=0&id=25f72da3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f72da3",
  null
  
)

export default component.exports